const initialize = () => {
    
    // Log a GA event whenever the newsletter signup link is clicked
    $('a[href="https://forms.svmic.com/svmiccom-a5jfr/pages/kruin7oweewujgavxcaaa.html"]').click(function(){
        gtag('event', 'newsletter_signup_click');
    });

    // Log a GA events for main nav clicks
    $('.nav-main a').click(function(){
        let navLink = $(this).clone();
        $(navLink).find('svg').remove();
        let navLinkText = $(navLink).html().trim();
        gtag('event', 'nav_click', {
            'nav_item': navLinkText
        });
    });
    $('.vantage-button').click(function(){
        gtag('event', 'nav_click', {
            'nav_item': 'Vantage Login'
        });
    });
    $('.get-started-button').click(function(){
        gtag('event', 'nav_click', {
            'nav_item': 'Get Started'
        });
    });

    // Log a GA event if an external link resource is clicked
    $('#contentArea').on('click', '.external-resource-link', function() {
        const title = $(this).attr('data-resource-title');
        gtag('event', 'Resource_View', {
            'event_category': 'Resources',
            'event_label': title
        });
    });
};

export default {
    initialize,
};